export interface ITankPlanTypeAndOrb {
  key: string;
  value: string;
}

export interface ITankPlanCapacity {
  value: string;
  unit: string;
}

export interface ITankLimits {
  hh?: string;
  h?: string;
  l?: string;
  ll?: string;
}

export type actionType = "add" | "history";

export enum ETankPlanLogbook {
  bwl = "Ballast Water Log",
  mfsbA = "Marine Fuel Sulphur Part A",
  mfsbB = "Marine Fuel Sulphur Part B",
}

export interface ITankPlan {
  type: string;
  orb: string[];
  name: string;
  capacity: ITankPlanCapacity;
  limits?: ITankLimits;
  bwl?: boolean;
  mfsbA?: boolean;
  mfsbB?: boolean;
  tankid: string;
  order: number;
}

export interface ITankPlansHeader {
  label: string;
  width?: string;
}

export interface IValuePair {
  value: string;
  label: string;
}

export const getTankTypeLabel = (type: string) =>
  tankTypes.find(t => t.value === type)?.label ?? type;

export const matchesTankPlanSearch = (tank: ITankPlan, query: string) => {
  const typeLabel = getTankTypeLabel(tank.type).toLowerCase();
  return (
    tank.name?.toLowerCase().includes(query) ||
    tank.type?.toLowerCase().includes(query) ||
    typeLabel.includes(query)
  );
};

export const headers: ITankPlansHeader[] = [
  { label: "", width: "20px" },
  { label: "Type", width: "8%" },
  { label: "Name", width: "20%" },
  { label: "Capacity", width: "6%" },
  { label: "Limits", width: "12%" },
  { label: "Oil Record Book", width: "30%" },
  { label: "Ballast Water Log", width: "130px" },
  { label: "Marine Fuel Sulphur Part A", width: "150px" },
  { label: "Marine Fuel Sulphur Part B", width: "150px" },
  { label: "", width: "80px" },
];

export const tankTypes: IValuePair[] = [
  { value: "BT", label: "Ballast Tank" },
  { value: "CT", label: "Cargo Tank" },
  { value: "FT", label: "Fuel Tank" },
  { value: "LSFOT", label: "Low Sulphur Fuel Oil Tank" },
  { value: "LT", label: "Lubricant Tank" },
  { value: "ST", label: "Slop Tank" },
  { value: "WST", label: "Waste Tank" },
  { value: "WT", label: "Water Tank" },
  { value: "BTW", label: "Bilge Water Tank" },
  { value: "ORS", label: "Oily Residues" },
  { value: "SS", label: "Scale & Sludge" },
  { value: "DOT", label: "Dirty Oil Tank" },
  { value: "OIL", label: "Oil Tank" },
  { value: "OT", label: "Other" },
];

export const orbs: IValuePair[] = [
  {
    value: "*",
    label: "All",
  },
  {
    value: "B",
    label: "Ballast (A1)",
  },
  {
    value: "BC",
    label: "Ballast Cleaning (A3.3)",
  },
  {
    value: "OTW",
    label: "Oily Tanks Washings (B5)",
  },
  {
    value: "DBW",
    label: "Dirty Ballast Water (B5)",
  },
  {
    value: "OR",
    label: "Oily Residues (Sludge) (C.11.1)",
  },
  {
    value: "SS",
    label: "Scale & Sludge From Tank Cleaning (C.11.1)",
  },
  {
    value: "BTW",
    label: "Bilge Water Tank (C.11.1)",
  },
  {
    value: "DOT",
    label: "Dirty Oil Tank (C.11.1)",
  },
  {
    value: "C12.1",
    label:
      "Collection, transfer and disposal of oil residues (sludge) (C.12.1)",
  },
  {
    value: "C12.2",
    label:
      "Collection, transfer and disposal of oil residues (sludge) (C.12.2)",
  },
  {
    value: "C12.3",
    label:
      "Collection, transfer and disposal of oil residues (sludge) (C.12.3)",
  },
  {
    value: "C12.4",
    label:
      "Collection, transfer and disposal of oil residues (sludge) (C.12.4)",
  },
  {
    value: "D13",
    label: "Bilge Water (D13)",
  },
  {
    value: "BWD",
    label: "Bilge Water Disposal (D15.3)",
  },
  {
    value: "F",
    label: "Fuel (H.26.3)",
  },
  {
    value: "LO",
    label: "Lube Oil (H.26.4)",
  },
];
